import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function AlertModal({
    show,
    onHide,
    modalTitle,
    modalBody
}) {

    
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                keyboard={false}
                style={{transition: 'opacity 1s ease-in-out'}}
            >
                <Modal.Header closeButton>
                <Modal.Title> {modalTitle} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>       
    );

}

export default AlertModal;

